import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Request } from 'npx-family-happy-common';
import { map, of, takeUntil } from 'rxjs';
import { Subject, catchError } from 'rxjs';
import { RequestService } from 'src/app/requests-handling/request-service/request.service';
import { ToastService } from '../../services/toast-service/toast.service';

@Component({
  selector: 'app-request-state-handler',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './request-state-handler.component.html',
  styleUrl: './request-state-handler.component.scss'
})
export class RequestStateHandlerComponent implements OnInit, OnDestroy {
  @Input() request!: Request;

  requestState = new FormControl();
  hasChanges = false;
  isPartner = false;

  private unsubscribe = new Subject<void>();

  constructor(private requestService: RequestService, private toast: ToastService) {}

  ngOnInit(): void {
    this.initForm();
    this.requestState.valueChanges.pipe(
      takeUntil(this.unsubscribe),
    ).subscribe((value) => {
      this.hasChanges = true;
    });
  }

  initForm(){
    this.isPartner = this.request.requestPersonalInfo.requestCategory === 'NUTRITIONIST'
    || this.request.requestPersonalInfo.requestCategory === 'COACH'
    || this.request.requestPersonalInfo.requestCategory === 'PSYCHOLOGIST'
    || this.request.requestPersonalInfo.requestCategory === 'VIDEO_CONSULTATION'
    || this.request.requestPersonalInfo.requestCategory === 'IN_PERSON'
    || this.request.requestPersonalInfo.requestCategory === 'LONGEVITY'
    || this.request.requestPersonalInfo.requestCategory === 'CAREGIVER_CONSULT' ? true : false;

      this.requestState.setValue(this.request.operationalInfo.status);
  }

  /**
   * Riallinea il selettore allo stato della richiesta quando cambia da fuori (es. la chat Supporto caregiver
   * che risponde). Non sovrascrive una scelta dell'operatore non ancora salvata.
   */
  syncStatus(){
    if (!this.hasChanges) {
      this.requestState.setValue(this.request.operationalInfo.status, { emitEvent: false });
    }
  }

  updateState(){
    this.requestService.changeStatus(this.request.id, this.requestState.value).pipe(
      takeUntil(this.unsubscribe),
      map((request) => {
        this.request.operationalInfo.status = request.operationalInfo.status;
        this.hasChanges = false;
        this.toast.setAction('Stato della richiesta aggiornato con successo', true);
      }),
      catchError((err) => {
        this.toast.setAction('Errore durante l\'aggiornamento dello stato della richiesta', false);
        return of(null);
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
